import { BRANDS_ABBREVIATIONS, EUSKALTEL, LOCALE_ES, LOCALE_EU, LOCALE_GL, MUNDO_R, TELECABLE } from './utils/constants'

const messagesEs = require('./lang/es.json')
const messagesGl = require('./lang/gl.json')
const messagesEu = require('./lang/eu.json')

export const LANG_ES = {
  name: 'Español',
  code: LOCALE_ES,
  lang: 'Spanish',
  id: 'languageES'
}
export const LANG_GL = {
  name: 'Gallego',
  code: LOCALE_GL,
  lang: 'Galician',
  id: 'languageGL'
}
export const LANG_EU = {
  name: 'Euskera',
  code: LOCALE_EU,
  lang: 'Basque',
  id: 'languageEU'
}

export const APP_TRANSLATIONS_LIST = {
  [LOCALE_ES]: messagesEs,
  [LOCALE_GL]: messagesGl,
  [LOCALE_EU]: messagesEu
}

export const DEFAULT_LOCALE = LOCALE_ES

export const LANGUAGES_BY_BRAND = {
  [BRANDS_ABBREVIATIONS[EUSKALTEL]]: [LANG_ES, LANG_EU],
  [BRANDS_ABBREVIATIONS[MUNDO_R]]: [LANG_ES, LANG_GL],
  [BRANDS_ABBREVIATIONS[TELECABLE]]: [LANG_ES]
}
